import React from 'react';
import { GameState } from '../../types';
import { getPlayerDisplayById } from '../../utils/playerUtils';
import {
  OVERLAY_STYLES,
  GAME_OVER_OVERLAY_CARD,
  BUTTON_PRIMARY,
  BUTTON_SIZES
} from '../../constants/styles';

interface GameOverOverlayProps {
  gameState: GameState;
  onNewGame: () => void;
}

const GameOverOverlay: React.FC<GameOverOverlayProps> = ({ gameState, onNewGame }) => {
  if (!gameState.winner) return null;

  return (
    <div className={OVERLAY_STYLES}>
      <div className={GAME_OVER_OVERLAY_CARD}>
        <h2 className="text-2xl font-bold text-primary-900 dark:text-primary-100 mb-1">
          Game Over!
        </h2>
        <p className="text-lg text-primary-700 dark:text-primary-200 mb-4">
          {getPlayerDisplayById(gameState.winner, gameState.players)} wins!
        </p>
        <button
          onClick={onNewGame}
          className={`${BUTTON_PRIMARY} ${BUTTON_SIZES.md}`}
        >
          New Game
        </button>
      </div>
    </div>
  );
};

export default GameOverOverlay;